import { render, staticRenderFns } from "./CaretDownUpIcon.vue?vue&type=template&id=44e8ffd8"
import script from "./CaretDownUpIcon.vue?vue&type=script&lang=js"
export * from "./CaretDownUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports